document.addEventListener('DOMContentLoaded', function () {
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var revealEls = document.querySelectorAll('.reveal');

  function revealAll() {
    revealEls.forEach(function (el) { el.classList.add('in'); });
  }

  if (reduceMotion || !('IntersectionObserver' in window)) {
    revealAll();
  } else {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('in');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -35px' });
    revealEls.forEach(function (el) { observer.observe(el); });
    setTimeout(revealAll, 1200);
  }

  document.querySelectorAll('.feat-rail').forEach(function (rail) {
    var previous = rail.querySelector('.feat-arrow--prev');
    var next = rail.querySelector('.feat-arrow--next');
    function move(direction) {
      var track = rail.querySelector('.feat-track:not(.feat-track--hidden)');
      if (!track) return;
      var card = track.querySelector('.custom-collection-card, .feat-card');
      var distance = card ? card.getBoundingClientRect().width + 20 : track.clientWidth * .8;
      track.scrollBy({ left: direction * distance, behavior: reduceMotion ? 'auto' : 'smooth' });
    }
    if (previous) previous.addEventListener('click', function () { move(-1); });
    if (next) next.addEventListener('click', function () { move(1); });
  });

  document.querySelectorAll('[data-featured-tabs]').forEach(function (section) {
    var tabs = section.querySelectorAll('[data-featured-tab]');
    var panels = section.querySelectorAll('[data-featured-panel]');
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var target = tab.getAttribute('data-featured-tab');
        tabs.forEach(function (item) {
          var active = item === tab;
          item.classList.toggle('on', active);
          item.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        panels.forEach(function (panel) {
          panel.classList.toggle('feat-track--hidden', panel.getAttribute('data-featured-panel') !== target);
        });
      });
    });
  });

  function initializeHeroRotators(scope) {
    scope.querySelectorAll('.hero__rotate-word').forEach(function (rotator) {
      if (rotator.dataset.rotatorInitialized === 'true') return;
      var words = (rotator.getAttribute('data-words') || '')
        .split(',')
        .map(function (word) { return word.trim(); })
        .filter(Boolean);
      if (words.length < 2 || reduceMotion) return;

      rotator.dataset.rotatorInitialized = 'true';
      var currentIndex = Math.max(words.indexOf(rotator.textContent.trim()), 0);
      window.setInterval(function () {
        if (!document.documentElement.contains(rotator)) return;
        rotator.classList.add('is-out');
        window.setTimeout(function () {
          currentIndex = (currentIndex + 1) % words.length;
          rotator.textContent = words[currentIndex];
          rotator.classList.remove('is-out');
        }, 250);
      }, 1500);
    });
  }

  initializeHeroRotators(document);

  function initializeMembershipVideos(scope) {
    scope.querySelectorAll('[data-membership-video-wrap]').forEach(function (wrap) {
      if (wrap.dataset.videoInitialized === 'true') return;
      var video = wrap.querySelector('[data-membership-video]');
      var playButton = wrap.querySelector('[data-membership-video-play]');
      if (!video || !playButton) return;

      wrap.dataset.videoInitialized = 'true';

      function syncVideoState() {
        wrap.classList.toggle('is-playing', !video.paused && !video.ended);
      }

      function toggleVideo(event) {
        if (event) event.preventDefault();
        if (video.paused || video.ended) {
          video.play().then(syncVideoState).catch(function () {});
        } else {
          video.pause();
          syncVideoState();
        }
      }

      playButton.addEventListener('click', toggleVideo);
      video.addEventListener('click', toggleVideo);
      video.addEventListener('play', syncVideoState);
      video.addEventListener('pause', syncVideoState);
      video.addEventListener('ended', syncVideoState);
    });
  }

  initializeMembershipVideos(document);

  function initializeCreatorGalleries(scope) {
    scope.querySelectorAll('[data-creator-gallery]').forEach(function (gallery) {
      if (gallery.dataset.galleryInitialized === 'true') return;
      var track = gallery.querySelector('[data-creator-gallery-track]');
      var previous = gallery.querySelector('[data-creator-gallery-prev]');
      var next = gallery.querySelector('[data-creator-gallery-next]');
      if (!track || !previous || !next) return;

      gallery.dataset.galleryInitialized = 'true';

      function scrollStep() {
        var item = track.querySelector('.creator-bag__item');
        var styles = window.getComputedStyle(track);
        var gap = parseFloat(styles.columnGap || styles.gap) || 18;
        return (item ? item.getBoundingClientRect().width : 280) + gap;
      }

      previous.addEventListener('click', function () {
        track.scrollBy({ left: -scrollStep(), behavior: 'smooth' });
      });
      next.addEventListener('click', function () {
        track.scrollBy({ left: scrollStep(), behavior: 'smooth' });
      });
    });
  }

  initializeCreatorGalleries(document);

  function initializeWarrantyPhotos(scope) {
    scope.querySelectorAll('[data-warranty-photos]').forEach(function (input) {
      if (input.dataset.photoPreviewInitialized === 'true') return;
      var field = input.closest('.warranty-claim__field');
      var preview = field && field.querySelector('[data-warranty-thumbs]');
      if (!preview) return;
      input.dataset.photoPreviewInitialized = 'true';
      input.addEventListener('change', function () {
        preview.innerHTML = '';
        Array.prototype.slice.call(input.files || [], 0, 5).forEach(function (file) {
          if (!file.type || file.type.indexOf('image/') !== 0) return;
          var image = document.createElement('img');
          image.alt = file.name;
          image.src = URL.createObjectURL(file);
          image.addEventListener('load', function () { URL.revokeObjectURL(image.src); }, { once: true });
          preview.appendChild(image);
        });
      });
    });
  }

  initializeWarrantyPhotos(document);

  var stickyBar = document.getElementById('stickybar');
  var hero = document.querySelector('.hero');
  var footer = document.querySelector('.footer');
  if (stickyBar && hero) {
    function updateStickyBar() {
      var pastHero = window.scrollY > hero.offsetHeight * .8;
      var footerVisible = false;
      if (footer) {
        var footerRect = footer.getBoundingClientRect();
        footerVisible = footerRect.top < window.innerHeight && footerRect.bottom > 0;
      }
      stickyBar.classList.toggle('show', pastHero && !footerVisible);
    }
    updateStickyBar();
    window.addEventListener('scroll', updateStickyBar, { passive: true });
  }

  var floatingCart = document.getElementById('FloatingCartButton');
  if (floatingCart) {
    function syncFloatingCartCount() {
      var headerCount = document.querySelector('#cart-icon-bubble .cart-count-bubble [aria-hidden="true"]');
      var floatingCount = floatingCart.querySelector('.cartfab__count');
      if (floatingCount) floatingCount.textContent = headerCount ? headerCount.textContent.trim() : '0';
    }

    floatingCart.addEventListener('click', function () {
      var headerCart = document.getElementById('cart-icon-bubble');
      if (headerCart) headerCart.click();
      else window.location.href = window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart';
    });

    var siteHeader = document.querySelector('header');
    if (siteHeader) {
      new MutationObserver(syncFloatingCartCount).observe(siteHeader, {
        childList: true,
        subtree: true,
        characterData: true
      });
    }

    syncFloatingCartCount();
  }

  /* Dawn renders search inside the sticky header. Move the complete search
     component to body while open so fixed positioning is truly viewport-based. */
  document.querySelectorAll('details-modal.header__search').forEach(function (searchModal) {
    if (searchModal.dataset.searchPortalInitialized === 'true') return;
    var details = searchModal.querySelector('details');
    var predictiveResults = searchModal.querySelector('[data-predictive-search]');
    var searchInput = searchModal.querySelector('input[type="search"]');
    var searchForm = searchInput && searchInput.form;
    var defaultSearchMarkup = predictiveResults ? predictiveResults.innerHTML : '';
    var originalParent = searchModal.parentNode;
    var placeholder = document.createComment('header-search-portal');
    originalParent.insertBefore(placeholder, searchModal);
    searchModal.dataset.searchPortalInitialized = 'true';

    var stickyHeader = searchModal.closest('sticky-header');
    if (stickyHeader) stickyHeader.searchModal = searchModal;

    function restoreSearchToHeader() {
      if (placeholder.parentNode && searchModal.parentNode !== originalParent) {
        placeholder.parentNode.insertBefore(searchModal, placeholder.nextSibling);
      }
    }

    /* Run before Dawn's close handler focuses the summary button. Otherwise
       the browser focuses its temporary body position and jumps to the bottom. */
    var closeButton = searchModal.querySelector('.search-modal__close-button');
    var summaryButton = searchModal.querySelector('summary');
    if (closeButton) closeButton.addEventListener('click', restoreSearchToHeader, true);
    if (summaryButton) {
      summaryButton.addEventListener('click', function () {
        if (details.open) restoreSearchToHeader();
      }, true);
    }
    details.addEventListener('keyup', function (event) {
      if (event.code && event.code.toUpperCase() === 'ESCAPE') restoreSearchToHeader();
    }, true);

    function restoreDefaultSearchContent() {
      if (!predictiveResults || !searchInput || searchInput.value.trim() !== '') return;
      predictiveResults.innerHTML = defaultSearchMarkup;
    }

    if (searchInput) {
      searchInput.addEventListener('input', function () {
        if (searchInput.value.trim() === '') {
          window.requestAnimationFrame(restoreDefaultSearchContent);
        }
      });
    }
    if (searchForm) {
      searchForm.addEventListener('reset', function () {
        window.setTimeout(restoreDefaultSearchContent, 0);
      });
    }

    new MutationObserver(function () {
      if (details.open) {
        if (searchModal.parentNode !== document.body) document.body.appendChild(searchModal);
      } else {
        restoreSearchToHeader();
      }
    }).observe(details, { attributes: true, attributeFilter: ['open'] });
  });

  document.addEventListener('shopify:section:load', function (event) {
    revealAll();
    initializeHeroRotators(event.target);
    initializeMembershipVideos(event.target);
    initializeCreatorGalleries(event.target);
    initializeWarrantyPhotos(event.target);
  });
});
